export const GET_VIDEO = "GET_VIDEO";
export const FETCH_VIDEOS = "FETCH_VIDEOS";
export const SET_VIDEOS_L = "SET_VIDEOS_L";
export const SET_VIDEOS_O = "SET_VIDEOS_O";
